import { ScopedCssBaseline } from "@mui/material";
import React, { FC, PropsWithChildren } from "react";
import { Route } from "wouter";
import { SentryErrorBoundary } from "../providers/SentryErrorBoundary";

/**
 * Add wrappers for each component
 */
export const ComponentContainer: FC<PropsWithChildren> = ({ children }) => (
  <Route>
    <SentryErrorBoundary>
      <ScopedCssBaseline>{children}</ScopedCssBaseline>
    </SentryErrorBoundary>
  </Route>
);
